/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import parameters from '@jira/servicedesk__customer-service-hubs/src/__generated__/ServiceHubsPageQuery$parameters.ts';
import type {
	HelpCenterSortOrder,
	ServiceHubsPageQuery,
} from '@jira/servicedesk__customer-service-hubs/src/__generated__/ServiceHubsPageQuery.graphql.ts';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const NUMBER_OF_HELP_CENTERS_INITIAL_FETCH = 20;
const SORT_ORDER: HelpCenterSortOrder = 'CREATED_DATE_DESCENDING';

type HelpCenterSettingsServiceHubsAppEntryPointComponentProps = EntryPointComponent<
	{ serviceHubsQuery: ServiceHubsPageQuery },
	{},
	{},
	{} | null
>;

export const helpCenterSettingsServiceHubsAppEntryPoint: EntryPoint<
	HelpCenterSettingsServiceHubsAppEntryPointComponentProps,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<HelpCenterSettingsServiceHubsAppEntryPointComponentProps>(
		/* webpackChunkName: "async-help-center-settings-service-hubs-app" */ './HelpCenterSettingServiceHubsAppWithJCSLicenseCheck.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ tenantContext: { cloudId, activationId } }: EntryPointRouteParams) => {
		return {
			queries: {
				serviceHubsQuery: {
					parameters,
					variables: {
						cloudId,
						workspaceAri: `ari:cloud:jira:${cloudId}:workspace/${activationId}`,
						SORT_ORDER,
						NUMBER_OF_HELP_CENTERS_INITIAL_FETCH,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
